var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueFrillTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.5805 32.0468C91.7568 25.5094 81.982 25.5094 77.1583 32.0468L75.6278 34.1212C73.1966 37.4161 68.9388 38.7995 65.0352 37.5629L62.5777 36.7844C54.8327 34.3307 46.9247 40.0762 46.8648 48.2004L46.8459 50.7782C46.8157 54.8729 44.1842 58.4948 40.2993 59.7888L37.8535 60.6035C30.1454 63.1709 27.1248 72.4673 31.8517 79.075L33.3516 81.1717C35.734 84.502 35.734 88.979 33.3516 92.3094L31.8518 94.406C27.1248 101.014 30.1454 110.31 37.8535 112.878L40.2993 113.692C44.1842 114.986 46.8157 118.608 46.8459 122.703L46.8648 125.281C46.9247 133.405 54.8327 139.15 62.5777 136.697L65.0352 135.918C68.9388 134.681 73.1966 136.065 75.6278 139.36L77.1583 141.434C81.982 147.972 91.7568 147.972 96.5805 141.434L98.1111 139.36C100.542 136.065 104.8 134.681 108.704 135.918L111.161 136.697C118.906 139.15 126.814 133.405 126.874 125.281L126.893 122.703C126.923 118.608 129.555 114.986 133.44 113.692L135.885 112.878C143.593 110.31 146.614 101.014 141.887 94.406L140.387 92.3094C138.005 88.979 138.005 84.502 140.387 81.1717L141.887 79.075C146.614 72.4673 143.593 63.1709 135.885 60.6034L133.44 59.7888C129.555 58.4948 126.923 54.8729 126.893 50.7782L126.874 48.2004C126.814 40.0762 118.906 34.3307 111.161 36.7844L108.704 37.5629C104.8 38.7995 100.542 37.4161 98.1111 34.1212L96.5805 32.0468Z",
    fill: "#154DDD",
    stroke: "#154DDD",
    strokeWidth: 2.49692
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5551,
    cy: 24.223,
    r: 1.75038,
    fill: "#154DDD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1799,
    cy: 49.6096,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8049,
    cy: 79.6486,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.6175,
    cy: 29.9143,
    r: 1.31279,
    fill: "#154DDD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.0549,
    cy: 4.96894,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.203,
    cy: 20.1291,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.836,
    cy: 36.7658,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9221,
    cy: 125.738,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.078,
    cy: 53.9807,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.25,
    cy: 17.9417,
    r: 1.31279,
    fill: "#154DDD"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.195,
    cy: 123.996,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.133,
    cy: 129.688,
    r: 1.31279,
    fill: "#154DDD"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.828,
    cy: 146.75,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.3596,
    cy: 153.422,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.7971,
    cy: 159.004,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.2346,
    cy: 169.414,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.8051,
    cy: 46.9769,
    r: 1.75038,
    fill: "#154DDD"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.578,
    cy: 86.3596,
    r: 0.87519,
    fill: "#154DDD"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.266,
    cy: 82.4222,
    r: 1.31279,
    fill: "#154DDD"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.446,
    cy: 170.379,
    r: 1.75038,
    fill: "#154DDD"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5473,
    cy: 146.746,
    r: 1.75038,
    fill: "#154DDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.106 92.0606L6.17422 98.7047C5.17021 99.0987 4.04586 98.5374 3.75728 97.4982C3.47002 96.4638 4.13657 95.4069 5.19384 95.2204L23.106 92.0606Z",
    fill: "#154DDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1363 88.0365L8.94544 88.7983C8.22255 88.8435 7.61937 88.2533 7.64881 87.5296C7.67813 86.8092 8.32175 86.2708 9.03598 86.3692L21.1363 88.0365Z",
    fill: "#154DDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.516 150.421L121.162 166.435C121.852 167.385 121.57 168.723 120.554 169.313C119.543 169.899 118.247 169.487 117.76 168.424L109.516 150.421Z",
    fill: "#154DDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.822 153.586L109.97 166.22C110.216 166.969 109.759 167.767 108.989 167.934C108.222 168.101 107.478 167.571 107.386 166.791L105.822 153.586Z",
    fill: "#154DDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.101 156.924L73.587 170.356C73.5273 170.886 73.0311 171.254 72.5069 171.157C71.9845 171.061 71.6523 170.543 71.7828 170.028L75.101 156.924Z",
    fill: "#154DDD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1757 15.5587L86.6964 2.05167C86.7169 1.51908 86.2816 1.08076 85.7489 1.09765C85.2179 1.11449 84.8117 1.57673 84.8633 2.1055L86.1757 15.5587Z",
    fill: "#154DDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5311 145.18L43.6435 152.62C43.3537 153.062 42.7458 153.155 42.3367 152.821C41.9295 152.489 41.8971 151.879 42.2669 151.505L48.5311 145.18Z",
    fill: "#154DDD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0792 15.9379L53.5813 4.95593C53.1367 4.30473 53.3532 3.41189 54.0467 3.03665C54.737 2.66314 55.599 2.96568 55.9044 3.68869L61.0792 15.9379Z",
    fill: "#154DDD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.381 20.2375L122.376 3.65854C122.969 2.67545 122.581 1.3955 121.542 0.907119C120.508 0.420981 119.28 0.931601 118.895 2.00763L112.381 20.2375Z",
    fill: "#154DDD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.15 130.102L17.8045 140.475C16.8353 141.09 16.6111 142.409 17.3226 143.309C18.0309 144.206 19.3577 144.297 20.1821 143.506L34.15 130.102Z",
    fill: "#154DDD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.573 27.5043C129.897 26.9035 131.056 25.4878 133.09 24.6318C135.634 23.5617 136.117 22.1088 135.776 20.5026C135.435 18.8965 132.138 18.2838 131.869 20.8785C131.6 23.4732 136.79 24.2174 139.064 20.0117C140.883 16.6471 142.875 15.9448 143.643 16.0142",
    stroke: "#154DDD",
    strokeWidth: 1.01448
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1207 60.5188C17.6515 60.0225 16.1665 58.9546 13.9796 58.654C11.2459 58.2783 10.4034 56.9998 10.3172 55.3601C10.2311 53.7205 13.2572 52.2758 14.1883 54.7126C15.1195 57.1494 10.2985 59.2108 7.01435 55.7364C4.38704 52.9568 2.28121 52.7936 1.55671 53.0594",
    stroke: "#154DDD",
    strokeWidth: 1.01448
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.45 141.88C131.621 142.541 132.406 144.193 134.176 145.513C136.388 147.162 136.509 148.688 135.792 150.165C135.076 151.643 131.728 151.447 132.09 148.863C132.451 146.28 137.668 146.803 138.866 151.431C139.825 155.134 141.59 156.293 142.353 156.41",
    stroke: "#154DDD",
    strokeWidth: 1.01448
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154.767 105.38L170.034 111.997C170.939 112.389 171.985 111.912 172.282 110.971C172.578 110.035 172.002 109.047 171.042 108.843L154.767 105.38Z",
    fill: "#154DDD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2568 41.1183L15.4233 34.83C14.9587 34.4572 14.2736 34.5681 13.9505 35.0685C13.6289 35.5666 13.8065 36.2335 14.3332 36.5057L23.2568 41.1183Z",
    fill: "#154DDD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140.951 46.3175L154.66 32.0295C155.473 31.1823 156.84 31.2245 157.599 32.1203C158.355 33.0119 158.178 34.3606 157.217 35.0271L140.951 46.3175Z",
    fill: "#154DDD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M144.725 49.4018L156.429 43.0904C157.123 42.7162 157.988 43.0246 158.289 43.7535C158.589 44.479 158.198 45.3047 157.447 45.533L144.725 49.4018Z",
    fill: "#154DDD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106 76.1313L81.5004 100.564L67 86.1033L72.5819 80.5365L81.5004 89.4308L100.418 70.5645L106 76.1313Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFrillTick);
export default __webpack_public_path__ + "static/media/blue_frill_tick.fafbf1321cf0dc6743632f216597f9e6.svg";
export { ForwardRef as ReactComponent };